import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SearchInputInfoComponent} from './search-input/search-input-info/search-input-info.component';
import {SearchInputContainerComponent} from './search-input/search-input-container/search-input-container.component';
import {SearchInputSwitchComponent} from './search-input/search-input-switch/search-input-switch.component';
import {SearchInputDropdownComponent} from './search-input/search-input-dropdown/search-input-dropdown.component';
import {SearchInputTextComponent} from './search-input/search-input-text/search-input-text.component';
import {SearchContainerComponent} from './search-container/search-container.component';
import {BrowserModule} from '@angular/platform-browser';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {NgxDatatableModule} from '@almaobservatory/ngx-datatable';
import {SearchPopoverComponent} from './search-popover/search-popover.component';
import {NgTruncatePipeModule} from 'angular-pipes';
import {AsaxCommonModule} from 'asax-common';
import {
  SourceResolverInfoComponent
} from './search-input/search-input-source-resolver/source-resolver-info/source-resolver-info.component';
import {
  SourceResolverInputComponent
} from './search-input/search-input-source-resolver/source-resolver-input/source-resolver-input.component';
import {
  TargetListInputComponent
} from './search-input/search-input-target-list/target-list-input/target-list-input.component';
import {
  TargetListInfoComponent
} from './search-input/search-input-target-list/target-list-info/target-list-info.component';
import {
  SearchInputTypeaheadComponent
} from "./search-input/search-input-typeahead/typeahead-input/search-input-typeahead.component";
import {
  SearchInputScienceKeywordsComponent
} from "./search-input/search-input-science-keywords/science-keywords-input/search-input-science-keywords.component";
import {
  SearchInputSkyObjectsComponent
} from "./search-input/search-input-sky-objects/sky-objects-input/search-input-sky-objects.component";


@NgModule({
  declarations: [
    SearchContainerComponent,
    SearchInputInfoComponent,
    SearchInputContainerComponent,
    SearchInputSwitchComponent,
    SearchInputDropdownComponent,
    SearchInputTypeaheadComponent,
    SearchInputScienceKeywordsComponent,
    SearchInputSkyObjectsComponent,
    SearchInputTextComponent,
    SearchPopoverComponent,
    SourceResolverInfoComponent,
    SourceResolverInputComponent,
    TargetListInputComponent,
    TargetListInfoComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    FormsModule,
    HttpClientModule,
    NgxDatatableModule,
    NgTruncatePipeModule,
    AsaxCommonModule
  ],
  exports: [
    SearchContainerComponent
  ]
})
export class SearchModule {
}
